export enum TelehealthPreference {
  YES = "true",
  NO = "false",
  HYBRID = "HYBRID",
} 